import { render, staticRenderFns } from "./showDetails.vue?vue&type=template&id=78105866&scoped=true"
import script from "./showDetails.vue?vue&type=script&lang=js"
export * from "./showDetails.vue?vue&type=script&lang=js"
import style0 from "./showDetails.vue?vue&type=style&index=0&id=78105866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78105866",
  null
  
)

export default component.exports